import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// All auth is carried via httpOnly cookie set by the backend on /api/auth/login.
// We never store the JWT in localStorage to avoid XSS exposure.
export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});
